import { Selector } from '@ngxs/store';
import { ProOrganizerState, ProOrganizerStateModel } from './pro-organizer-request.state';

export class ProOrganizerRequestSelectors {

  @Selector([ProOrganizerState])
  static loading(state: ProOrganizerStateModel) {
    return state.loading;
  }

  @Selector([ProOrganizerState])
  static error(state: ProOrganizerStateModel) {
    return state.error;
  }

  @Selector([ProOrganizerState])
  static lastRequest(state: ProOrganizerStateModel) {
    return state.data;
  }
}
